// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"5f8d1e48","159":"397a8d99","190":"97309a36","260":"70de39e0","267":"d6335cae","325":"f8a34f38","453":"bdcb934d","479":"91fced64","488":"61ce493e","595":"8a25e4b3","858":"e14d1803","913":"1a8dd667","951":"3cea0d38","959":"5a7c8e39"}[chunkId] + ".chunk.js";
};